import { EventEmitter, Injectable } from '@angular/core';
import { Idol } from 'src/app/shared/interfaces/idol';
import { PCard } from 'src/app/shared/interfaces/pCard';
import { SCard } from 'src/app/shared/interfaces/sCard';

import { ShinyColorsUrlService } from '../shinycolors-url/shinycolors-url.service';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  constructor(public scUrlService: ShinyColorsUrlService) {}

  activeIds = new EventEmitter<number[]>();
  storedIds: number[] = [];

  mobileTitle = new EventEmitter<string>();

  emitActiveIds(ids: number[]) {
    this.storedIds = ids;
    this.activeIds.emit(ids);
  }

  emitMobileTitle(title: string, stripe: boolean = false) {
    let display: string = title;
    if (stripe) {
      display = title.match(/(【.*】)/)![1];
    }
    this.mobileTitle.emit(display);
  }

  generateDefaultMeta(): { name: string; content: string }[] {
    return [
      {
        name: 'og:type',
        content: 'website',
      },
      {
        name: 'og:url',
        content: 'http://bbang.shinymaskr.work:4000/',
      },
      {
        name: 'og:title',
        content: ' ~ 백업용 빵집방주 ~ ',
      },
      {
        name: 'og:description',
        content:
          '카드 발매 일정, 카드 정보, 게임 플롯 및 기타 등 아이돌 마스터 샤이니 컬러즈 게임의 정보를 공유하는 사이트입니다.',
      },
      {
        name: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        name: 'twitter:url',
        content: 'http://bbang.shinymaskr.work:4000/',
      },
      {
        name: 'twitter:title',
        content: ' ~ 백업용 빵집방주 ~ ',
      },
      {
        name: 'twitter:description',
        content:
          '카드 발매 일정, 카드 정보, 게임 플롯 및 기타 등 아이돌 마스터 샤이니 컬러즈 게임의 정보를 공유하는 사이트입니다.',
      },
      {
        name: 'description',
        content:
          '카드 발매 일정, 카드 정보, 게임 플롯 및 기타 등 아이돌 마스터 샤이니 컬러즈 게임의 정보를 공유하는 사이트입니다.',
      },
    ];
  }

  generateIdolMeta(idolInfo: Idol): { name: string; content: string }[] {
    return [
      { name: 'og:type', content: 'website' },
      { name: 'og:title', content: idolInfo.hiragana },
      {
        name: 'og:description',
        content: `이름: ${idolInfo.hiragana}\n생일: ${idolInfo.birthday}\n소속유닛: ${idolInfo.unit.unitName}`,
      },
      {
        name: 'og:image',
        content: this.scUrlService.getIdolIcon(idolInfo.idolId),
      },
      { name: 'theme-color', content: idolInfo.color1 },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: idolInfo.hiragana },
      {
        name: 'twitter:description',
        content: `이름: ${idolInfo.hiragana}\n생일: ${idolInfo.birthday}\n소속유닛: ${idolInfo.unit.unitName}`,
      },
      {
        name: 'twitter:url',
        content: `http://bbang.shinymaskr.work:4000/idolinfo?idolid=${idolInfo.idolId}`,
      },
      {
        name: 'twitter:image',
        content: this.scUrlService.getIdolIcon(idolInfo.idolId),
      },
      {
        name: 'description',
        content: `이름: ${idolInfo.hiragana}\n생일: ${idolInfo.birthday}\n소속유닛: ${idolInfo.unit.unitName}`,
      },
    ];
  }

  generateReverseLookupMeta(): { name: string; content: string }[] {
    return [
      {
        name: 'og:type',
        content: 'website',
      },
      {
        name: 'og:url',
        content: 'http://bbang.shinymaskr.work:4000/r-lookup',
      },
      {
        name: 'og:title',
        content: ' ~ 스킬 체크 ~ ',
      },
      {
        name: 'og:description',
        content: '서포트 스킬 레벨에 따른 서포트 카드 체크',
      },
      {
        name: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        name: 'twitter:url',
        content: 'http://bbang.shinymaskr.work:4000/r-lookup',
      },
      {
        name: 'twitter:title',
        content: ' ~ 스킬 체크 ~ ',
      },
      {
        name: 'twitter:description',
        content: '서포트 스킬 레벨에 따른 서포트 카드 체크',
      },
      {
        name: 'description',
        content: '서포트 스킬 레벨에 따른 서포트 카드 체크',
      },
    ];
  }

  generateCardMeta(card: PCard | SCard): { name: string; content: string }[] {
    return [
      { name: 'og:type', content: 'website' },
      { name: 'og:title', content: card.cardName },
      {
        name: 'og:image',
        content: card.cardType.match('P_')
          ? this.scUrlService.getCardUrl(card.enzaId)
          : this.scUrlService.getSupportCardUrl(card.enzaId),
      },
      { name: 'theme-color', content: card.idol.color1 },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: card.cardName },
      {
        name: 'twitter:url',
        content: `http://bbang.shinymaskr.work:4000/${
          card.cardType.match('P_') ? 'pcardinfo' : 'scardinfo'
        }?uuid=${card.cardUuid}`,
      },
      {
        name: 'twitter:image',
        content: card.cardType.match('P_')
          ? this.scUrlService.getCardUrl(card.enzaId)
          : this.scUrlService.getSupportCardUrl(card.enzaId),
      },
      {
        name: 'description',
        content: `카드 이름: ${card.cardName}\n 카드 타입: ${card.cardType}\n 출시일: ${card.releaseDate}`,
      },
    ];
  }

  isSrCard(theType: string): boolean {
    return theType.match(/_SR/) !== null;
  }

  isSsrCard(theType: string): boolean {
    return theType.match(/_SSR/) !== null || theType.match(/_UR/) !== null;
  }

  translateGetMethod(method: string): string {
    switch (method) {
      case 'Default':
        return '기본카드';
      case 'IdolRoad':
        return '아이돌로드';
      case 'GeneralGasha':
        return '통상가챠';
      case 'LimitedGasha':
        return '한정가챠';
      case 'Events':
        return '이벤트';
      case 'FesReward':
        return '페스보상';
      case 'LiveReward':
        return '라이브관람보상';
      case 'TwilightCollect':
        return '트와코레가챠';
      case 'TwilightCollection':
        return '트와코레가챠';
      case 'PaidGasha':
        return '유료가챠보상';
      case 'MySongCollection':
        return '마이코레가챠';
      case 'MvGasha':
        return '마이코레가챠';
      case 'Present':
        return '운영선물';
      case 'Collabo':
        return '콜라보카드';
      case 'CollaboGasha':
        return '콜라보카드';
      case 'CollaboEvents':
        return '콜라보이벤트';
      case 'CollabTwilightCollection':
        return '콜라보트와코레';
      case 'AnimeReward':
        return '애니메이션보상';
      case 'SituationDrama':
        return '시나리오드라마';
      case 'ParallelCollection':
        return '파라코레';
      default:
        return method;
    }
  }

  translateIdeaNote(idea: string): string {
    switch (idea) {
      case 'vocal':
        return '보컬';
      case 'dance':
        return '댄스';
      case 'visual':
        return '비주얼';
      case 'mental':
        return '멘탈';
      case 'skill_point':
        return '어필';
      default:
        return '';
    }
  }

  convertHirameki(hirameki: string): string {
    switch (hirameki) {
      case 'Vo':
        return 'vocal';
      case 'Da':
        return 'dance';
      case 'Vi':
        return 'visual';
      case 'Me':
        return 'mental';
      default:
        return '';
    }
  }

  translateProficiency(proficiency: string): string {
    switch (proficiency) {
      case 'teamwork':
        return '단결력';
      case 'feel_stable':
        return '안정감';
      case 'expressive_power':
        return '표현력';
      case 'sing_ability':
        return '가창력';
      case 'concentration':
        return '집중력';
      default:
        return '';
    }
  }

  supportSkillBound() {
    return {
      S_UR: [60, 65, 70, 75, 80],
      S_SSR: [60, 65, 70, 75, 80],
      S_SR: [50, 55, 60, 65, 70],
      S_R: [40, 45, 50, 55, 60],
      S_N: [5, 10],
    };
  }
}
